import React, { useState } from 'react'
import DraggableOccasionOptions from './DraggableOccasionOptions'

export default function SortableOccasionsTab({
    form,
    formKey=null,
    handleManualUpdate
}) {

    const [currentInput, setCurrentInput] = useState('')

    const isDisabled = currentInput === ''

    const handleOnDragEnd = (items) => {
        handleManualUpdate(formKey, items)
    }

    const handleOnAdd = (e) => {
        if (/click/i.test(e.type) || /enter/i.test(e.key)) {
            e.preventDefault()
            let items = [...form[formKey]]
            items.push(currentInput)
            setCurrentInput('')
            handleManualUpdate(formKey, items)
        }
    }

    const handleOnRemove = (targetIndex) => {
        const items = form[formKey].filter((_, i) => i !== targetIndex)
        handleManualUpdate(formKey, items)
    }

    return !form[formKey] ? '' : <div>
        <div className="pb-3">
            <div className="input-group">
                <input
                    type='text'
                    name='add_new'
                    className='form-control'
                    value={currentInput}
                    autoFocus
                    onChange={(e) => setCurrentInput(e.target.value)}
                    onKeyDown={handleOnAdd}
                />
                <div className="input-group-append">
                    <button
                        children='Add'
                        type='button'
                        className={`btn ${isDisabled ? 'btn-secondary' : 'btn-primary'}`}
                        disabled={isDisabled}
                        onClick={handleOnAdd}
                    />
                </div>
            </div>
        </div>

        <hr className="mt-4 mb-3" />

        <DraggableOccasionOptions
            options={form[formKey]}
            onRemove={handleOnRemove}
            onDragEnd={handleOnDragEnd}
        />
    </div>
}
